import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { MainScreen } from "./pages/MainScreen/MainScreen";
import { ReportsScreen } from "./pages/ReportsScreen/ReportsScreen";
import Auth0Login from "./pages/Auth0Login/Auth0Login";
import { AuthGuard } from "./components/guards/AuthGuard";
import { NotFound } from "./pages/NotFound/NotFound";
import { ReportScreen } from "./pages/ReportScreen/ReportScreen";
import { UploadReportScreen } from "./pages/UploadReportScreen/UploadReportScreen";
import { ReportUserAssignment } from "./pages/ReportUserAssignment/ReportUserAssignment";
// import { ClientOnboardingScreen } from "./pages/ClientOnboardingScreen/ClientOnboardingScreen";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Auth0Login />} />
      <Route element={<AuthGuard />}>
        <Route element={<Layout />}>
          <Route path="/" element={<MainScreen />} />
          <Route path="/reports" element={<ReportsScreen />} />
          <Route path="/report/:id" element={<ReportScreen />} />
          <Route path="/upload" element={<UploadReportScreen />} />
          <Route path="/assign-users-report" element={<ReportUserAssignment />} />
          {/* <Route path="/onboard" element={<ClientOnboardingScreen />} /> */}
          <Route path="/callback" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}